import React from "react";
import {TicTacParafh,TictacDivFlex,TicTacParafh1,TictacDivRight,TicTacView,TictacDivBlock
} from "../FormasTicTac";
import Nofoundpage from "../../../pages/Nofoundpage";

function TicTacText( {lengthDimention, capture, parafh} ){
  let x = [];
  for ( let index = lengthDimention + 1; index < parafh.length; index++ ){
    x.push(parafh[index]);
  }
  switch ( lengthDimention ){
    case 1:
      return (
        <>
          <TicTacParafh parafh={parafh[0]} />
          <TictacDivFlex capture={capture[0]} parafh={parafh[1]} />
          <TicTacParafh1 parafh={x} />
        </>
      );
    case 2:
      return (
        <>
          <TicTacParafh parafh={parafh[0]} />
          <TictacDivFlex capture={capture[0]} parafh={parafh[1]} />
          <TicTacParafh parafh={parafh[2]} />
          <TictacDivRight capture={capture[1]} parafh={parafh[3]} />
          <TicTacParafh1 parafh={x} />
        </>
      );
    case 3:
      return (
        <>
          <TicTacParafh parafh={parafh[0]} />
          <TictacDivBlock capture={capture[0]} parafh={parafh[1]} />
          <TictacDivFlex capture={capture[1]} parafh={parafh[2]} />
          <TictacDivRight capture={capture[2]} parafh={parafh[3]} />
          <TicTacParafh1 parafh={x} />
        </>
      );
    case 4:
      return (
        <>
          <TicTacParafh parafh={parafh[0]} />
          <TictacDivFlex capture={capture[0]} parafh={parafh[1]} />
          <TicTacParafh parafh={parafh[2]} />
          <TictacDivRight capture={capture[1]} parafh={parafh[3]} />
          <TictacDivFlex capture={capture[2]} parafh={parafh[4]} />
          <TicTacView capture={capture[3]} />
          <TicTacParafh1 parafh={x} />
        </>
      );
    case 5:
      return (
        <>
          <TicTacParafh parafh={parafh[0]} />
          <TictacDivFlex capture={capture[0]} parafh={parafh[1]} />
          <TicTacParafh parafh={parafh[2]} />
          <TictacDivRight capture={capture[1]} parafh={parafh[3]} />
          <TictacDivRight capture={capture[2]} parafh={parafh[4]} />
          <TictacDivFlex capture={capture[3]} parafh={parafh[5]} />
          <TicTacView capture={capture[4]} />
          <TicTacParafh1 parafh={x} />
        </>
      );
    case 12:
      return (
        <>
          <TicTacParafh parafh={parafh[0]} />
          <TictacDivRight capture={capture[0]} parafh={parafh[1]} />
          <TicTacView capture={capture[1]}/>
          <TicTacParafh parafh={parafh[2]} />
          <TictacDivFlex capture={capture[2]} parafh={parafh[3]} />
          <TicTacParafh parafh={parafh[4]} />
          <TicTacParafh parafh={parafh[5]} />
          <TicTacParafh parafh={parafh[6]} />
          <TicTacParafh parafh={parafh[7]} />
          <TicTacView capture={capture[5]} />
          <TicTacParafh parafh={parafh[8]} />
          <TicTacParafh parafh={parafh[9]} />
          <TicTacParafh parafh={parafh[10]} />
          <TicTacView capture={capture[3]} />
          <TicTacParafh parafh={parafh[11]} />
          <TicTacParafh parafh={parafh[12]} />
          <TicTacParafh1 parafh={x} />
          <TicTacView capture={capture[6]} />
          <TicTacView capture={capture[7]} />
          <TicTacView capture={capture[8]} />
          <TicTacView capture={capture[9]} />
          <TicTacView capture={capture[10]} />
          <TicTacView capture={capture[11]} />
        </>
      );
    default:
      return <Nofoundpage />;
  }
}
export default TicTacText;